import PropTypes from 'prop-types';
import React from 'react';
import EmptyStates from '../empty-states';
import withTranslate from '../../../common/components/with-translate/with-translate';

const AccountSuspended = ({ t, ...props }) => (
  <EmptyStates
    title={t('account-suspended.account-suspended')}
    content={t('account-suspended.contact-owner')}
    type="account_suspended"
    {...props}
  />
);

AccountSuspended.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslate(AccountSuspended);
